module.exports = __webpack_public_path__ + "img/logo.fbbeed36.gif";